import { PrescriptionPrescriptionTypeEnum } from '@redteclab/api/clients/bully'

export const priceAccessorIsPrescription = (
  currentPrescriptionType: PrescriptionPrescriptionTypeEnum,
): boolean =>
  PrescriptionPrescriptionTypeEnum.NoPrescription !== currentPrescriptionType &&
  Object.values(PrescriptionPrescriptionTypeEnum).includes(
    currentPrescriptionType,
  )
